import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Operator setting'
  }
];

@Component({
  selector: 'page-operator-setting',
  templateUrl: './operator-setting.html',
  styleUrls: ['./operator-setting.scss']
})

export class PageOperatorSetting implements OnInit {
  //initial & Search
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  loadingIndicator: boolean = true;
  key:any="";
  selected=[];
  filtered:any;
  ctrl:FormControl;
  autoItems = [];
  searchId:String;
  print="";
  //form
  form: FormGroup;
  selectedLineCtrl = new FormControl();
  selectedProcessCtrl = new FormControl();
  selectedSkillCtrl = new FormControl();
  selectedPositionCtrl = new FormControl();
  selectPermissionCtrl = new FormControl();
  id:String;
  arrProcess = [];arrlines=[];arrOperators=[];arrPositions=[];arrSkills=[];arrPermission=[];

  ckedit:boolean=false;
  //upload
  fileupload:string;
  //data table
  data:any;
  rows = [];temp=[];skills=[];
  //upload file
  imageSrc:any;
  urlApi=environment.url+"/api/uploadToServerDir.php";
  Name:string; 
  myFile:File; /* property of File type */
  picture:String="";operator:String=null;
  //dialog
  dialogRefWarning: MdDialogRef<WarningOperatorSettingDialog>;
  dialogRef: MdDialogRef<operatorSettingDialog>;
  setId:any;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/operator-in-process-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/operator-in-process-list-export.php";
  qrUrl:string = "";
  ckUrl:boolean=false;

  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    
    this.getAutocompleteSearchOperator();
    this.getSkill();
    this.getPosition();
    this.getOperator();
    this.getLine();
    this.getStartData();
    this.getPermission();
    this._sharedService.emitChange(this.pageTitle);

  }
  getPermission(){
    this.httpservice.fetchget('getJSON_group_permission.php?',(data)=>{
     // this.products = data;
     this.arrPermission = data;
     console.log('menu',data);
    });
  }

  getAutocompleteSearchOperator(){
    this.httpservice.fetchget('getJSON_operator_name.php?',(data) => {
      this.autoItems = data;
      console.log('------this.operator------', this.autoItems);
    });
    this.ctrl = new FormControl();
    this.filtered = this.ctrl.valueChanges
    .startWith(null)
    .map(val => {
      if (isArray(val)) {
        this.key = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.key = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.autoItems.filter((s) => new RegExp(val, 'gi').test(s.tb98f_operator_name)) : this.autoItems;
    });
  }

  getOperatorId(id:String){
        this.searchId = id;
  }
  openPrint(){

    for(let i=0;i<this.selected.length;i++){
          
              //console.log('----select---',this.selected[i]['tbf62_id']);
              if(this.selected[i]['tbf62_id']!="undefined"){
                this.print+="&print[]="+this.selected[i]['tb98f_id'];
      }    
    }
    
    let popupWinindow
    popupWinindow = window.open( environment.url+'/api/print-operator.php?'+this.print, '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no width=auto');
    this.selected = [];
    this.print="";
    
    }
  onActivate(event) {
    //console.log('Activate Event', event);
  }
  onSelect({ selected }) {
    console.log('Select Event', this.selected);
   
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  intervalGetData(){
    return setInterval(() => {
      if(this.setId.runCount>2){
        clearInterval(this.setId);
        }
      this.getStartData();
      console.log('------this.setId------',this.setId);
     }, 1000);
  }

  getStartData(){
    this.httpservice.fetchget('getJSON_operator_name.php?',(data) => {
      this.rows = data;
      this.picture = this.sysPath+'/picture/no_image.jpg';
      this.loadingIndicator = false;
    });
  }
  getSkill(){
    this.httpservice.fetchget('getJSON_skill.php?',data=>{
        this.arrSkills = data;
      });
  }
  setSkill(id:String){
    this.httpservice.fetchget('getJSON_operator_skill.php?tpn_id='+id+'&tb98f_id='+this.operator,data=>{
        if(data.length!=0){
            this.selectedSkillCtrl.setValue(data[0].tb104_operator_skill_tb104f_id);
        }else{
            this.selectedSkillCtrl.setValue(6);
        }
        console.log('setSkill',data.length);
        
    });
  }

  saveSkill(){
    this.skills = [];
    let data = {tpr_id:this.selectedLineCtrl.value,tpn_id:this.selectedProcessCtrl.value,skill:this.selectedSkillCtrl.value,operator:this.operator}
    this.httpservice.fetchpost('insertDataSkill.php',data,cb=>{
      
      this.httpservice.fetchget('getJSON_operator_in_process_list.php?id='+this.id,data=>{
        this.skills=data;
      });

    });
  }

  getPosition(){
      this.httpservice.fetchget('getJSON_position.php?',data=>{
        this.arrPositions = data;
      });
     
  }
  getOperator(){
      this.httpservice.fetchget('getJSON_operator_name.php?',data=>{
        this.arrOperators = data;
        this.temp = data;
      });
  }

  getProcess(tpr_id:String){
    this.httpservice.fetchget('getJSON_process_name.php?tpr_id='+tpr_id,(data)=>{
      this.arrProcess = data;
    });
  }

  getLine(){
    this.httpservice.fetchget('getJSON_line.php?',(data)=>{
      this.arrlines = data;
    });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('deleteOperator.php', val, (cb) => {});
  this.setId = this.intervalGetData();
  this.cancelEdit();
  }

  setedit(id:string){
    this.cancelEdit();
    this.ckUrl = true;
    this.id = id;
    this.ckedit=true;
    this.operator=null;
    this.httpservice.fetchget('getJSON_operator.php?id='+id,(data) => {
      this.form.controls.name.setValue(data[0].tb98f_operator_name);
      this.form.controls.code.setValue(data[0].tb98f_operator_code);
      this.operator=data[0].tb98f_id;

      if(data[0].tb98f_operator_picture.length>0){
        this.picture = this.sysPath+'/picture/operator/'+data[0].tb98f_operator_picture;
      }else{
        this.picture = this.sysPath+'/picture/no_image.jpg';
      }
    
      this.selectedPositionCtrl.setValue(data[0].tb98f_position);
      this.selectedLineCtrl.setValue(data[0].tb17_productionline_tpr_id);
      this.selectPermissionCtrl.setValue(data[0].tb130f_id)
      this.getProcess(data[0].tb17_productionline_tpr_id);
    });

    this.httpservice.fetchget('getJSON_operator_in_process_list.php?id='+id,data=>{
      this.skills=data;
    });

  }
  edit(){
    this.setId = this.intervalGetData();
    if (this.myFile != null) {
      this.fileupload = this.myFile.name;
    } else {
      this.fileupload = "";
    }
    this.ckedit = false;
    this.data = {
      id:this.id,
      code:this.form.controls.code.value,
      name:this.form.controls.name.value,
      line:this.selectedLineCtrl.value,
      position:this.selectedPositionCtrl.value,
      permission:this.selectPermissionCtrl.value,
      filename:this.fileupload
    }
    // insert data
    this.httpservice.fetchpost('editDataOperator.php', this.data, (cb) => {});
      //upload image
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }
  this.cancelEdit();
  }

  cancelEdit(){
    this.ckedit = false;
    this.ckUrl = false;
    this.selectedPositionCtrl.reset();
    this.selectedLineCtrl.reset();
    this.selectedSkillCtrl.reset();
    this.selectedProcessCtrl.reset();
    this.selectPermissionCtrl.reset();
    this.form.reset();
    this.skills = [];
    this.picture=null;
    this.fileupload="";
    this.operator;
  }


save(){
  this.setId = this.intervalGetData();
  if (this.myFile != null) {
    this.fileupload = this.myFile.name;
  } else {
    this.fileupload = "";
  }
  this.data = {
    code:this.form.controls.code.value,
    name:this.form.controls.name.value,
    line:this.selectedLineCtrl.value,
    position:this.selectedPositionCtrl.value,
    process:this.selectedProcessCtrl.value,
    permission:this.selectPermissionCtrl.value,
    filename:this.fileupload
  }
  // insert data
  console.log('data',this.data);
  this.httpservice.fetchpost('insertPostDataOperator.php', this.data, (cb) => {});
  //upload image
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }

  this.cancelEdit();


}
urlExists(url) {
  return fetch(url, {mode: "no-cors"})
    .then(res => true)
    .catch(err => false)
}
search(){ 
  clearInterval(this.setId);
  this.httpservice.fetchget('getJSON_operator.php?id='+this.searchId,(data) => {
    this.rows = data;
  });
  this.ctrl.reset();
  this.key="";
  }
ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      pictureInput:[null, Validators.compose([Validators.required])]
    });
   
}
attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;
    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
}

updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tb98f_operator_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.rows = temp;
  }

  uploadPhoto(file:File){
    
    var formData = new FormData();
    formData.append('file', file);
    let data = {file:file,path:"../picture/operator/"};
    var request = new XMLHttpRequest();
    request.open('POST', this.urlApi);
    request.send(formData);

    //this.httpservice.fetchpost('uploadToServerDir.php',data,(cb)=>{});
  }

  openDeleteDialog(id:string) {
    let dialogRef = this.dialog.open(operatorSettingDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      if(result==='1'){
          this.delete(id);
      }else{
      }
    });
  }

  openQrDialog(){

    this.httpservice.fetchget('print-operator-qr.php?id='+this.id,data=>{
      const printContent = document.getElementById("print-section");
      const WindowPrt = window.open('', '', 'left=0,top=0,width=700,height=400,toolbar=0,scrollbars=0,status=0');
      WindowPrt.document.write(printContent.innerHTML);
      WindowPrt.document.write('<title>Operator QR-Code</title>');
      WindowPrt.document.write('<link rel="stylesheet" type="text/css" href="'+this.sysPath+'/assets/css/bootstrap.css">');
      WindowPrt.document.write('<link rel="stylesheet" type="text/css" href="'+this.sysPath+'/assets/css/bootstrap.min.css">');
      WindowPrt.document.close();
      WindowPrt.onload = function() {
      WindowPrt.focus();
      WindowPrt.print();
      WindowPrt.close();
      
      };


    });

}//end print

  openEditDialog(){
    let dialogRef = this.dialog.open(operatorSettingDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.name.value!=null && this.form.controls.code.value!=null){
          this.edit();
        }else{
          this.warningDialog('Please fill code , name');
        }
      }else{
      }
    });
  }
  openDialog() {
    let dialogRef = this.dialog.open(operatorSettingDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      if(result==='1'){
        if(this.form.controls.name.value!=null && this.form.controls.code.value){
          this.save();
        }else{
          this.warningDialog('Please fill in name, lsl,usl,lcl and ucl value!');
        }
      }else{
      }
    });
  }

  warningDialog(message: string) {
    let dialogRef = this.dialog.open(WarningOperatorSettingDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if (result === '1') {
      } else {
      }
    });
  }
}
//dialog
@Component({
  selector: 'operator-setting-dialog',
  templateUrl: 'dialog.html',
})
export class operatorSettingDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<operatorSettingDialog>) {}
}

//warning
@Component({
  selector: 'warning-operator-setting-dialog',
  templateUrl: 'warning.html',
})
export class WarningOperatorSettingDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningOperatorSettingDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/operator-setting/operator-setting.ts